angular.module('autoremind.users')
    .directive('adminUserCommunication', ['accountService', 'audioServiceDowngraded', 'jobService', 'dialogs',
    function (accountService, audioServiceDowngraded, jobService, dialogs) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/users/admin-users-communication.html',
            scope: {
                userInfo: "=",
                viewModel: '=model'
            },
            required: 'userInfo',
            link: function (scope, element, attrs) {
                console.log('adminUserCommunication', scope.userInfo);
                scope.isDataLoadStarted = false;
                // Setup watcher to load data the first time the tab is viewed (even if by route rather than click on tab)
                if (angular.isDefined(scope.viewModel.activeTabIndex)) {
                    scope.$watch('viewModel.activeTabIndex', function (newTabIndex, oldTabIndex) {
                        if (angular.isDefined(newTabIndex) && !scope.isDataLoadStarted && newTabIndex === scope.viewModel.tabIndexes['communication']) {
                            scope.isDataLoadStarted = true;
                            scope.init();
                        }
                    });
                }
                scope.viewModel.adminUsersCommunication = {
                    availableCategories: angular.copy(jobService.availableCategories),
                    categoriesForRevert: []
                };
                scope.loadingIndicator = {
                    refCount: 0,
                    state: false
                };
                var existInAvailable = function (categoryId) {
                    for (var i in jobService.availableCategories) {
                        if (jobService.availableCategories[i].communicationsCategoryId === categoryId) {
                            return true;
                        }
                    }
                    return false;
                };
                var existInUser = function (categoryId) {
                    for (var i in scope.userInfo.communication.categories) {
                        if (scope.userInfo.communication.categories[i].communicationsCategoryId === categoryId) {
                            return true;
                        }
                    }
                    return false;
                };
                var listener = scope.$watch('userInfo', function () {
                    if (angular.isDefined(scope.userInfo.communication)) {
                        listener();
                        // Remove if user has categories no longer in available (e.g. "educational" has been deprecated
                        for (var j in scope.userInfo.communication.categories) {
                            if (!existInAvailable(scope.userInfo.communication.categories[j].communicationsCategoryId)) {
                                console.log("Removing '" + scope.userInfo.communication.categories[j].communicationsCategoryId +
                                    "' from user's communication settings");
                                scope.userInfo.communication.categories.splice(j, 1);
                            }
                        }
                        // Add to user if new categories has been added to available but not in user yet
                        for (var i in jobService.availableCategories) {
                            if (!existInUser(jobService.availableCategories[i].communicationsCategoryId)) {
                                console.log("Adding '" + scope.userInfo.communication.categories[i].communicationsCategoryId +
                                    "' to user's communication settings");
                                scope.userInfo.communication.categories.push(jobService.availableCategories[i]);
                            }
                        }
                        scope.viewModel.adminUsersCommunication.categoriesForRevert = angular.copy(scope.userInfo.communication.categories);
                    }
                }, true);
                scope.viewModel.adminUsersCommunication.changed = false;
                scope.changed = function () {
                    scope.viewModel.adminUsersCommunication.changed = true;
                };
                scope.mediaTypes = {
                    email: {
                        enabled: false
                    },
                    sms: {
                        enabled: false
                    },
                    voice: {
                        enabled: false
                    }
                };
                // Used as reference in the view
                scope.emailDevices = accountService.emailDevices;
                scope.smsDevices = accountService.smsDevices;
                scope.voiceDevices = accountService.voiceDevices;
                scope.init = function () {
                    accountService.getUserCommunications(scope.userInfo, scope.loadingIndicator, true)
                        .then(function (userInfo) {
                        console.log('Got communication settings');
                        // TODO: Remove this once Admin Devices are all fixed
                        // scope.initMediaTypeOptions();
                        // Adding default value if not set yet
                        if (!angular.isDefined(userInfo.communication.price.sms) || userInfo.communication.price.sms === '') {
                            userInfo.communication.price.sms = 0.08;
                        }
                        // Adding default value if not set yet
                        if (!angular.isDefined(userInfo.communication.price.voice) || userInfo.communication.price.voice === '') {
                            userInfo.communication.price.voice = 0.08;
                        }
                    });
                };
                scope.saveCommunicationsSettings = function () {
                    // TODO: Remove this once Admin Devices are all fixed
                    /*
                    for (var index in scope.userInfo.media) {
                        var media = scope.userInfo.media[index];
                        if (scope.mediaTypes[media.type].enabled) {
                            media.device = scope.mediaTypes[media.type].device;
                        } else {
                            delete media.device;
                        }
                    }
                    */
                    scope.viewModel.adminUsersCommunication.changed = false;
                    accountService.saveUserCommunication(scope.userInfo, scope.loadingIndicator)
                        .then(function () {
                        console.log('Communication settings saved');
                    }, function () {
                        scope.userInfo.communication.categories = angular.copy(scope.viewModel.adminUsersCommunication.categoriesForRevert);
                    });
                };
                scope.playingNow = -1;
                scope.isPlaying = false;
                scope.play = function ($event, id) {
                    if (!angular.isDefined(id) || id === '') {
                        return;
                    }
                    scope.isPlaying = true;
                    scope.playingNow = id;
                    var audio = new Audio();
                    audio.src = audioServiceDowngraded.getUrlForSoundId() + id;
                    audioServiceDowngraded.setAudio(audio);
                    audioServiceDowngraded.playAudio();
                };
                scope.stop = function () {
                    scope.playingNow = -1;
                    scope.isPlaying = false;
                    audioServiceDowngraded.stopAudio();
                };
                scope.setHeadPos = function (playPercent) {
                    return;
                };
            }
        };
    }]);
//# sourceMappingURL=admin-users-communication.js.map